(ns ui.components.radix-ui.separator.view
  (:require
   [reagent.core :as r]
   ["@radix-ui/react-separator" :as Separator]))

(defn adapt
  [cls-name]
  (r/adapt-react-class (aget Separator cls-name)))

(def separator-root (adapt "Root"))

(defn view
  [{:keys [orientation]}]
  (let [orientation (or orientation :horizontal)]
    [separator-root
     {:orientation orientation
      :class       "w-[1px] h-full bg-base-gloomy-border"}]))
